module.exports = __webpack_public_path__ + "static/media/support.8e69acad.svg";